import { IRoomRectangle, ToolType } from "../../types/Floorplan.types";

export interface IRoomRects {
    roomRectangles?: IRoomRectangle[];
    selectedRoomIdx?: number;
    selectedTool?: ToolType;
}

const RoomRects = (props: IRoomRects) => {
    const { roomRectangles, selectedRoomIdx, selectedTool } = props;
    if (roomRectangles && roomRectangles.length > 0) {
        return (
            <g id="internalRooms">
                { roomRectangles && roomRectangles.length > 0 && roomRectangles.map((room,idx) => {
                    let className = "room room-" + idx;
                    let transform: string | undefined = undefined;
                    if (selectedTool === "Pointer" && selectedRoomIdx === idx) {
                        className = "draggable draggableRoom-" + idx;
                    }
                    // if (!room.bookable) className += " nonAvailableDesk";
                    // if (room.rotation !== 0) {
                    //     transform = `rotate(${room.rotation})`;
                    // }
                    return (
                        <rect className={className} key={`ir_${idx}`} data-idx={idx} x={room.x} y={room.y} width={room.width} height={room.height} stroke="black" fill="white" />                                        
                    );
                })}
            </g>
        );
    }
    return null;
};

export default RoomRects;